import customInputStyle from "assets/jss/material-dashboard-pro-react/components/customInputStyle.jsx";
import {cardTitle, tooltip} from "assets/jss/material-dashboard-pro-react.jsx";
import buttonStyle from "assets/jss/material-dashboard-pro-react/components/buttonStyle.jsx";

const impersonateUserStyle = {
  ...customInputStyle,
  cardTitle,
  tooltip,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
    "& small": {
      fontSize: "80%",
      fontWeight: "400"
    },
    textTransform: "none"
  },
  ...buttonStyle,
  floatingImpersonate: {
    position: "fixed",
    right: "30px",
    bottom: "30px",
    zIndex: "9999"
  },
  impersonateFloatingButton: {
    float: "right"
  },
  impersonateFloatingCard: {
    width: 285,
    maxWidth: "calc(100vw - 60px)",
  }
};

export default impersonateUserStyle;
